import { render } from "./TipTapInput.vue?vue&type=template&id=6c7c3479"
import script from "./TipTapInput.vue?vue&type=script&lang=js"
export * from "./TipTapInput.vue?vue&type=script&lang=js"

import "./TipTapInput.vue?vue&type=style&index=0&id=6c7c3479&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__